import { SystemStatus, SystemStatusAppliance } from '@ekkogmbh/apisdk';
import { Paper, Stack, Typography } from '@mui/material';
import { useCallback, useEffect, useRef, useState } from 'react';
import useEkko from 'src/Common/Providers/EkkoProvider';
import useRequest from 'src/Common/Hooks/useRequest';
import { LoadingMask } from 'src/Common/Components/LoadingMask';
import SystemStatusBox from './SystemStatusBox';
import { enqueueSnackbar } from 'notistack';

export const SystemStatusContent = (): React.JSX.Element => {
  const { api } = useEkko();

  const intervalRef = useRef<number | undefined>();

  const [isFetching, startFetching] = useRequest<SystemStatus>();
  const [appliances, setAppliances] = useState<SystemStatusAppliance[]>([
    {
      status: 'OFFLINE',
      technology: {
        name: 'not-found',
        baseUrl: '',
      },
      information: {
        summaryOfLabels: {
          totalTagCount: 0,
          status: {
            successfulTagCount: 0,
            processingTagCount: 0,
            timeoutTagCount: 0,
          },
          batteryStatus: {
            goodBatteryTagCount: 0,
            badBatteryTagCount: 0,
          },
          signalStrength: {
            excellentSignalTagCount: 0,
            goodSignalTagCount: 0,
            badSignalTagCount: 0,
          },
        },
        summaryOfAccessPoints: {
          totalAccessPointCount: 0,
          connectedAccessPointCount: 0,
        },
      },
      tags: {
        factoryId: '-',
      },
    },
  ]);

  const fetchStatus = useCallback(() => {
    startFetching(
      () => api.getSystemStatus(),
      (s) => {
        // setAppliances([]);
        setAppliances(s?.serviceStatus ?? []);
      },
      (e) => {
        enqueueSnackbar(e.message, { variant: 'error' });
        setAppliances([]);
      },
    );
  }, [api]);

  /** on mount / unmount */
  useEffect(() => {
    fetchStatus();
    intervalRef.current = window.setInterval(fetchStatus, 30 * 1000);
    return () => {
      window.clearInterval(intervalRef.current);
    };
  }, [fetchStatus]);

  return (
    <>
      {isFetching && <LoadingMask width={75} height={75} />}
      {appliances.length === 0 && <Typography minHeight={200}>nothing found</Typography>}
      <Stack spacing={2} direction={'column'}>
        {appliances.map((appliance, index) => (
          <Paper
            key={index}
            sx={{
              width: '100%',
              boxShadow: 5,
              padding: 2,
              marginBottom: 4,
              paddingBottom: 4,
              position: 'relative',
            }}
          >
            <SystemStatusBox appliance={appliance} />
          </Paper>
        ))}
      </Stack>
    </>
  );
};
